import { useEffect } from 'react';
import { OfferPageContextProvider, useOfferPageContext } from 'pages/offer/context';
import { Loader } from 'shared/ui';
import { Spacing, SpacingDirection, SpacingSize } from './spacing';
import styles from './page.module.scss';
import {
  Benefits,
  EmployeeDecision,
  HeadBanner,
  MainTasks,
  Position,
  Reward,
  Header,
  LookForwardText,
  Footer,
  MotivateBanner,
} from './';

export const OfferPageContainer = () => (
  <OfferPageContextProvider>
    <OfferPage />
  </OfferPageContextProvider>
);

//TODO: обраюатывать ошибку 404
const OfferPage = () => {
  const { isLoading, isError, errorText } = useOfferPageContext();

  useEffect(() => {
    document.title = 'Предложение о работе';
  }, []);

  if (isLoading) {
    return <Loader className={styles.loaderContainer} />;
  }

  if (isError) {
    return <div>{errorText}</div>;
  }

  return (
    <Spacing size={SpacingSize.large} direction={SpacingDirection.vertical} className={styles.offerPage}>
      <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.headerSpacing}>
        <Header />
        <HeadBanner />
      </Spacing>
      <Position />
      <Reward />
      <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.benefitsSpacing}>
        <Benefits />
        <MotivateBanner />
      </Spacing>
      <MainTasks />
      <EmployeeDecision />
      <LookForwardText />
      <Footer />
      <div id="offer-generator-page-qa" className={styles.dataQaElement} />
    </Spacing>
  );
};
